import { useEffect, useState } from "react";

export default function ScrollTopButton() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    return (
        <>
            {
              isVisible && <button className="scroll-top-btn" onClick={scrollToTop}>
                    <img src={require("../../../assets/images/icon/scroll-top.png")} style={{width: "20px", height: "20px"}}></img>
                </button>
            }
        </>
    )
}